import { render, staticRenderFns } from "./tenderContent.vue?vue&type=template&id=90378d64&scoped=true&"
import script from "./tenderContent.vue?vue&type=script&lang=js&"
export * from "./tenderContent.vue?vue&type=script&lang=js&"
import style0 from "./tenderContent.vue?vue&type=style&index=0&id=90378d64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90378d64",
  null
  
)

export default component.exports